<template>
  <v-chip
    label
    class="base-chip no-select"
    :class="{ shrink }"
    :style="{
      color: '#000',
      backgroundColor: styles[`${chipColor}Background`],
      width
    }"
  >
    <slot />
  </v-chip>
</template>

<script>
import styles from "@/sass/chips-colors.scss";
import { APPLICATION_STATUSES, COMPILANCE_STATUSES } from "@/utils/bookings";

export default {
  name: "Chip",
  data() {
    return {
      styles,
      defaultColor: "gray"
    };
  },
  computed: {
    chipColor() {
      return (
        this.color ||
        (this.status && this.getColorByStatus(this.status)) ||
        this.defaultColor
      );
    }
  },
  props: {
    color: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    shrink: Boolean
  },
  methods: {
    getColorByStatus(status) {
      const {
        SHORTLISTED,
        APPROVED,
        REJECTED,
        ALLOCATED,
        CONFIRMED,
        WITHDRAWN
      } = APPLICATION_STATUSES;

      const { PARTIAL, COMPLETE } = COMPILANCE_STATUSES;

      switch (status.toLowerCase()) {
        case CONFIRMED:
        case COMPLETE:
          return "green";
        case APPROVED:
          return "blue";
        case SHORTLISTED:
        case PARTIAL:
          return "yellow";
        case ALLOCATED:
          return "purple";
        case REJECTED:
        case WITHDRAWN:
          return "red";
        default:
          return this.defaultColor;
      }
    }
  }
};
</script>

<style scoped></style>
